import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";

const data = [
    { name: "Electronics / PCB", value: 28, color: "#7C3AED" },
    { name: "3D Printing", value: 24, color: "#3B82F6" },
    { name: "CNC", value: 18, color: "#06B6D4" },
    { name: "Robotics", value: 12, color: "#F97316" },
    { name: "EV / Automotive", value: 10, color: "#EC4899" },
    { name: "Other", value: 8, color: "#94A3B8" },
];

export default function CategoryChart() {
    return (
        <div className="flex flex-col h-full">
            {/* Doughnut */}
            <div className="h-[220px]">
                <ResponsiveContainer width="100%" height="100%">
                    <PieChart>
                        <Pie
                            data={data}
                            dataKey="value"
                            nameKey="name"
                            innerRadius="62%"
                            outerRadius="95%"
                            paddingAngle={3}
                            cornerRadius={6}
                            startAngle={90}
                            endAngle={-270}
                            stroke="none"
                        >
                            {data.map((entry, index) => (
                                <Cell key={index} fill={entry.color} />
                            ))}
                        </Pie>
                        <Tooltip
                            formatter={(value) => `${value}%`}
                            contentStyle={{
                                borderRadius: 12,
                                border: "1px solid #E5E7EB",
                                fontSize: 13,
                            }}
                        />
                    </PieChart>
                </ResponsiveContainer>
            </div>

            {/* Legend */}
            <div className="flex-1 px-6 pb-2 mt-2 space-y-3 overflow-auto">
                {data.map((entry, index) => (
                    <div
                        key={index}
                        className="flex items-center justify-between text-sm"
                    >
                        <div className="flex items-center gap-2">
                            <span
                                className="w-2.5 h-2.5 rounded-full"
                                style={{ backgroundColor: entry.color }}
                            />
                            <span className="text-slate-600">{entry.name}</span>
                        </div>
                        <span className="font-semibold text-slate-800">
                            {entry.value}%
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
}